import { axiosCall, clientIdHeaderName } from '../../constants';
import { UserModel } from '../models';

export const autocomplete = async (
  getAccessTokenSilently: CallableFunction,
  clientId: string,
  q: string,
): Promise<UserModel[]> => {
  return axiosCall<UserModel[]>(
    getAccessTokenSilently,
    'users/autocomplete/' + q,
    'get',
    undefined,
    { [clientIdHeaderName]: clientId },
  );
};

export const autocompleteNoclientId = async (
  getAccessTokenSilently: CallableFunction,
  q: string,
): Promise<UserModel[]> => {
  return axiosCall<UserModel[]>(
    getAccessTokenSilently,
    'users/autocomplete/' + q,
    'get',
    undefined,
  );
};
